<template>
    <v-card v-if="myData != null" flat>
        <v-card-text>
            <v-row v-if="myData.skupiny.length == 0">
                <p>Nie je možné prihlasovať sa do skupín</p>
            </v-row>
            <v-row v-if="studentInfo">
              <small>
                <b>Všeobecné odomknutie:</b> {{ studentInfo.global_time }}; <b>Aktuálny serverový čas: </b>{{ studentInfo.server_time }}<br/>
                <b>Bonus:</b> {{ studentInfo.my_bonus }} minút (za priemer počas štúdia), <v-icon title="Detail predmetov" @click="showSubjects = true">edit</v-icon><br/>
                  <v-card  v-if="showSubjects"  class="mt-3"  outlined >
                    <v-card-title class="py-2">
                      Predmety<v-spacer></v-spacer><v-icon title="Zavrieť" class="btn-close" @click="showSubjects = false">close</v-icon>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-simple-table dense class="subjects-table">
                        <thead>
                          <tr>
                            <th>Názov </th>
                            <th>Semester </th>
                            <th>Rok </th>
                            <th>Známka </th>
                            <th>Bonus </th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            v-for="(predmet, index) in studentInfo.predmety"
                            :key="index"
                          >
                            <td>{{ predmet.nazov }}</td>
                            <td>{{ predmet.semester }}</td>
                            <td>{{ predmet.rok }}</td>
                            <td>{{ predmet.znamka }}</td>
                            <td>{{ predmet.bonus }}</td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-card-text>
                  </v-card>
                <b>Odomknutie pre teba:</b> {{ studentInfo.my_time }} o {{ studentInfo.seconds_left }} sekund ({{my_cas}}) <br/>
              </small>

            </v-row>
            <v-row v-for="skupina,index in myData.skupiny" :key="index" v-bind:id="'sk'+skupina.id" >
                <v-col cols=12 v-if="studentInfo">
                    <v-card variant="outlined">
                        <v-card-title>
                            <v-row style="margin:1px">
                                <v-icon v-if="myData.skupina_id == skupina.id" large color="green">done</v-icon>
                                <b>{{skupina.nazov}}</b> ({{skupina.volne}}/{{skupina.pocet}})
                                <v-spacer></v-spacer>
                                <v-icon v-if="studentInfo.seconds_left == 0 && myData.skupina_id != skupina.id && skupina.volne > 0" title="Zapíš ma" style="margin-right:5px;color:green" @click="zapisMa(skupina.id)">person_add</v-icon>
                                <v-icon v-if="studentInfo.seconds_left == 0 && myData.skupina_id == skupina.id" title="Odhlás ma" style="margin-right:5px; color:red" @click="odhlasMa(skupina.id)">person_remove</v-icon>
                                <v-icon title="Ukáž zoznam" style="margin-right:5px" @click="showList(skupina.id)">groups</v-icon>
                            </v-row>
                        </v-card-title>
                        <v-row v-if="skupina.id == rozbalitSkupinu">
                            <v-col cols=12 v-if="skupina.id == rozbalitSkupinu">
                                <v-card style="background-color:#E8F5E9" variant="outlined">
                                    <v-card-title>
                                        Zoznam prihlásených
                                        <v-icon class="btn-close" @click="rozbalitSkupinu=-1">close</v-icon>
                                    </v-card-title>
                                    <v-card-text>
                                        <ul  style="margin-left:10px">
                                            <li v-for="clovek,index in ludiaVSkupine" :key="index">
                                                {{clovek.nickname}}
                                            </li>
                                        </ul>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text style="background-color:#E8F5E9;margin-bottom:3px" v-if="myData.history.length > 0">
            <v-row style="margin:5px"><h3>History</h3></v-row>
            <v-row v-for="skupina,index in myData.history" :key="index" v-bind:id="'hi'+skupina.id">
                <v-col cols=12>
                    <v-card variant="outlined">
                        <v-card-title>
                            <v-row style="margin:5px">
                                {{skupina.rok}} / {{skupina.semester}} semester
                                <v-spacer></v-spacer>
                                {{skupina.rocnik}}. ročník - <b>{{skupina.nazov}}</b>
                                <v-spacer></v-spacer>
                                <v-icon title="Ukáž zoznam" style="margin-right:10px" @click="showList(skupina.id)">groups</v-icon>
                            </v-row>
                        </v-card-title>
                        <v-row v-if="skupina.id == rozbalitSkupinu">
                            <v-col cols=12 v-if="skupina.id == rozbalitSkupinu">
                                <v-card style="background-color:#E8F5E9" variant="outlined">
                                    <v-card-title>
                                        Zoznam prihlásených
                                        <v-icon class="btn-close" @click="rozbalitSkupinu=-1">close</v-icon>
                                    </v-card-title>
                                    <v-card-text>
                                        <ul style="margin-left:10px">
                                            <li v-for="clovek,index in ludiaVSkupine" :key="index">
                                                {{clovek.nickname}}
                                            </li>
                                        </ul>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import axios from '../../axios-auth.js'


export default {
    data() {
        return {
            myData : null,
            rozbalitSkupinu: -1,
            studentInfo: null,
            my_cas: '',
            showSubjects: false
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)
            //this.myData = null
            this.prepareData()
        },
        prepareData() {
            axios.get('/get-study-groups', this.$store.getters.getAxiosConfig)
            .then((res) => {
                this.myData = res.data
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
            axios.get('/get-group-registration', this.$store.getters.getAxiosConfig)
            .then((res) => {
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                }
                this.studentInfo = res.data
                let s = this.studentInfo.seconds_left
                const d  = Math.floor(s / 86400);
                const hh = Math.floor((s % 86400) / 3600);
                const mm = Math.floor((s % 3600) / 60);
                const ss = s % 60;

                this.my_cas = `${d}d ${String(hh).padStart(2,'0')}:${String(mm).padStart(2,'0')}:${String(ss).padStart(2,'0')}`;
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        showList(_skupina_id) {
            axios.get('/get-users-in-group/'+_skupina_id, this.$store.getters.getAxiosConfig)
            .then((res) => {
                this.ludiaVSkupine = res.data.list
                this.rozbalitSkupinu = _skupina_id
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        zapisMa(_skupina_id) {
            const _data = {
                skupina_id: _skupina_id,
            }
            axios.post('/set-user-to-group', _data, this.$store.getters.getAxiosConfig)
            .then((res) => {
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } else {
                    this.gototo('sk' + _skupina_id)
                    this.initData()
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        odhlasMa(_skupina_id) {
            const _data = {
                skupina_id: _skupina_id,
            }
            axios.post('/remove-user-from-group', _data, this.$store.getters.getAxiosConfig)
            .then((res) => {
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } else {
                    this.gototo('sk' + _skupina_id)
                    this.initData()
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        gototo(_id) {
            const myid = document.getElementById(_id);
            let position = myid.getBoundingClientRect()
            window.scrollTo(position.left, position.top + window.scrollY - 50);
        },
    }
}
</script>
<style>
.subjects-table th,
.subjects-table td {
  padding-right: 20px !important;
}
</style>
